import React from "react";
import styles from "./NotFound.module.css";

const NotFound = () => {
  return (
    <div className={styles.notFoundContainer}>
      <h1 className={styles.notFoundHeading}>404</h1>
      <p className={styles.notFoundText}>Oops! The page you're looking for doesn't exist.</p>
      <a href="/" className={styles.notFoundLink}>Go back to Home</a>
    </div>
  );
};

export default NotFound;

